export class FirstChar {
  constructor(public readonly text: string) {}

  value(): string {
    return this.text[0];
  }
}
